﻿/*
  ___ _  _ _____ _   _ ___ _____ _____   _____    
 |_ _| \| |_   _| | | |_ _|_   _|_ _\ \ / / __| TM
  | || .` | | | | |_| || |  | |  | | \ V /| _|    
 |___|_|\_|_|_|__\___/|___|_|_|_|___| \_/_|___| __
 |   \| __|  \/  |/ _ \ / __| _ \  /_\ / __\ \ / /
 | |) | _|| |\/| | (_) | (__|   / / _ \ (__ \ V / 
 |___/|___|_|  |_|\___/ \___|_|_\/_/ \_\___| |_|  

 © Manuel Valle C. - AromaItaliano SA, Costa Rica

*/
"use strict";

// GLOBAL VARIABLES

var copyright = 'Copyright 2016-2021 - Manuel Valle C., Aroma Italiano SA., Costa Rica';

var AgoraPIC = {
	version: '2.4',
	copyright: copyright,
	production: true
};

var mapReady = false;

var levelOneSlider, levelTwoSlider;
var map, markers, picCustomControl, featureLayer, overlays, highlighted, layers, filters, targetLayer, wBounds, lastMapBounds, lastTag;
var sidebar, fullscreen;
var featuresGroup = {};
var wTitle;
//var isEditing = false;
var closeTooltip, removeFeature;
var defaultZoom, fitBounds;
var topicsIndex = {};
var topicsData = {};

var customStyle = {
	fillColor: '#ffcc00',
	color: '#eob400',
	weight: 3,
	opacity: 0.65
};

var editor;
//var composerModified = false;
var editingMode = false;
var editorHeight;
var viewportHeight = (window.innerHeight||document.documentElement.clientHeight);
var composeMapReady = false;
var sliders = [];

// Set composerGEO to default settings 
var composerGEO = {lat: config.picapp.defaultLat, lng: config.picapp.defaultLng};	

if (navigator.geolocation && navigator.geolocation.hasOwnProperty('getCurrentPosition')) {
	navigator.geolocation.getCurrentPosition(function(p) { composerGEO = {lat: p.coords.latitude, lng: p.coords.longitude}});
} else { 
	//alert("Geolocation is not supported by this browser.");
}

consoleLog('[MAIN]');

// Global functions

function initRecentCards() {
	require(['bxslider'], function(bxslider) {
	var env = utils.findBootstrapEnvironment();
		$('.recent-cards-widget .recent-cards.carousel-mode').each(function(i, e) {
			var w = $('.recent-cards-widget').innerWidth(),
				s = 5;
			while (w/s < 300) {
				s--;
			}

			sliders[i] = $(e).bxSlider({
				slideWidth: ((w + 30) / s),//(env=='xs') ? ($('.recent-cards-widget').innerWidth() + 30) : ((w + 30) / i),
				minSlides: 1,
				maxSlides: 5, //(env=='xs') ? 1 : (env=='sm') ? 2 : 4, //( (env=='xs')||(env=='sm') ) ? 1 : 4,
				pager: $(e).hasClass('carousel-pagination') //app.widgets.recentCards.enableCarouselPagination ? true: false
			});

			$('a.bx-next, a.bx-prev, a.bx-pager-link').removeAttr("href").css("cursor","pointer");

			if (s==1) $('.recent-cards').css('margin-left','0px');
			if (s==1) $('.recent-cards-title').css('margin-left','15px');
		});
	});
};

function initMap() {
	if ($('#map_widget').length) {
		require(['pic-tools'], function(tools) {
		// Initialize the map
			tools.initMapboxCluster({
				mapElement: 'map_widget',
				fitBounds: false,
				zoomControl: false,
				dragging: true,
				layerType: '',
				clusterify: true
			}, function(err, data) {
				/*
				map.addControl(new L.Control.Fullscreen());
				//map.addControl(new L.Control.Sidebar('sidebar'));
				//sidebar = L.control.sidebar('sidebar').addTo(map);
				map.on('fullscreenchange', function () {
					if (map.isFullscreen()) {
						//$('#sidebar').show();
						$('.leaflet-control-fullscreen').hide();
					} else {
						//$('#sidebar').hide();
						$('.leaflet-control-fullscreen').show();
					}
				});
				*/
			});
		});
	};
};

function cantCreate(can) {
	if (can) {
		app.alertSuccess('La encuesta fue creada correctamente.');
	} else {
		app.alertError('la encuesta no fue procesada por falta de derechos');
	}
}

function consoleLog() {
	if (AgoraPIC && AgoraPIC.production===true) return;
	console.log(arguments[0], (arguments[1] ? arguments[1] : ''));
}; 

require(['slugify', 'leaflet'], function(slugify, _L_) {
    window.slugify = slugify
});

/**
 *	Events handlers
 */
function onScriptLoad(event, data) {
//	Hook handler:	action:script.load
//	Trigged in:		public/src/ajaxify.js
//	Hook data:		{ tpl_url, scripts: [...]}
//	Note:				Ovverrides stantard routes javascripts modules, generally stored in 'assets/src/client/' path,
//							with the ones stored in 'plugins/nodebb-plugin-picapp/client/' path. The module 'init' method is executed automatically.
	//var customRoutes = ['compose', 'maps', 'about', 'welcome', 'dash', 'map', 'mydash'];
	console.log('[MAIN - (action:script.load)');	// DEBUG ONLY

	if (!data) return;
	var customRoutes = [, 'about', 'welcome', 'dash', 'map', 'mydash', 'chart']; //'maps'
	var extendedRoutes = []; //['category'];
	var overridePath = 'plugins/nodebb-plugin-picapp/client/'+data.tpl_url;

	// Override standard javascript module with the one defined in plugin 
	if (customRoutes.indexOf(data.tpl_url)>-1) {
		var i = data.scripts.indexOf('forum/'+data.tpl_url);
		if (i>=0) data.scripts[i] = overridePath;
		consoleLog('[MAIN - (action:script.load)] OVERRIDDEN', data.scripts[i]);	// DEBUG ONLY
	};

/*
	// Extend standard javascript module with the extended one
	if (data.tpl_url=='topic') {
		data.scripts.unshift('topic-extended');
		consoleLog('[MAIN - (action:script.load)] TOPIC');	// DEBUG ONLY
	};
*/
	// Extend standard javascript module with the extended one
	if (extendedRoutes.indexOf(data.tpl_url)>-1) {
		data.scripts.push(overridePath+'-extended');
		consoleLog('[MAIN - (action:script.load)] EXTENDED', data.tpl_url);	// DEBUG ONLY
	};

	var t = data.scripts.indexOf('forum/tags');
	if ((t>=0)) {
		data.scripts[t] = 'plugins/nodebb-plugin-picapp/client/tags';
		consoleLog('TAGS!!');	// DEBUG ONLY
	};

//	if (data.tpl=='category' || app.template=='category') {
//		$('[id^=features-]  .fa-spinner').remove();
//	}
	// Widgets initialization functions
	initRecentCards(); 	// recent-cards-widget
	initMap();			// map-widget
};

function onAjaxifyLoadingTemplates(ev, data) {
//	Hook handler:	action:ajaxify.loadingTemplates
//	Trigger in:		public\src\ajaxify.js
//	Hook data:		{}
//	Note:			Disable footer widgets on selected templates
	console.log('[MAIN - (action:ajaxify.loadingTemplates)]');	// DEBUG ONLY
	var routes = ['map', 'maps', 'mapx', 'cat', 'form', 'edit'];
	
	if (routes.indexOf(app.template)>=0) {
		ajaxify.data.widgets.footer = [];
	};
};

function onUnload(ev) {
	consoleLog('[MAIN - (unload)]');
};

// Ajaxify events
$(window).on('action:script.load', onScriptLoad);
$(window).on('action:ajaxify.loadingTemplates', onAjaxifyLoadingTemplates);
// Global events
$(window).on('unload', onUnload);

$(document).ready(function () {
	console.log('[MAIN - (' + ajaxify.data.template.name + ' document.ready)]');

	$(window).on('action:app.load', function () {
		//
	});

	//require(['benchpress', 'pic-helpers', 'moment', 'maps'], function (benchpress, helpers, moment, maps) {
	//require(['benchpress', 'pic-helpers', 'maps', 'leaflet', 'leaflet.markercluster'], function (benchpress, helpers, maps, leaflet, markercluster) {
	require(['benchpress', 'pic-helpers', 'maps'], function (benchpress, helpers, maps) {
		// Globalize Moment module
		//window.moment = moment;
		// Register Benchpress Helpers
		Object.keys(helpers).forEach(function (helperName) {
			benchpress.registerHelper(helperName, helpers[helperName]);
		});
		// Init listeners
		maps.hooksHandler();
	});

	//	Remove unnecessary widgets
	var routes = ['map', 'maps', 'mapx', 'cat', 'form', 'edit'];
	if (routes.indexOf(app.template)>=0) {
		$('[widget-area="footer"]').parent().remove();
	};

	//	Animations 
	$('.animated-pulse').addClass("invisible").viewportChecker({
		classToAdd: 'visible animate__animated animate__pulse',
		offset: 100
	});

	$('.animated-fade').addClass("invisible").viewportChecker({
		classToAdd: 'visible animate__animated animate__fadeInUp',
		repeat: false,
		offset: 100
	});

	$('.animated-tada').addClass("invisible").viewportChecker({
		classToAdd: 'visible animate__animated animate__tada',
		repeat: false,
		offset: 100
	}) ;

	if (!utils.isTouchDevice() && app.template=='category') $('.gauge canvas').tooltip();

	//	SOCKET Event Handlers
	//socket.on('event:picapp.mapRefresh', mapRefresh);
	socket.on('event:picapp.cantCreate', cantCreate);
	
	//htmlRefresh();
			
	jQuery('.post').addClass("hidden").viewportChecker({
		classToAdd: 'visible animate__animated animate__fadeIn',
		offset: 100
	});
	
	/**
	 *		Composer section
	 */

	$(window).on('action:composer.enhance', function(ev, data) {
		require(['compose'], function(compose) {
			compose.init(data.container);
		});
	});

	$(window).on('action:composer.topic.new', function(ev, data) {
		ajaxify.go(
			'compose?cid=' + data.cid +
			(data.title ? '&title=' + encodeURIComponent(data.title) : '') +
			(data.body ? '&body=' + encodeURIComponent(data.body) : '')
		);
	});

	$(window).on('action:composer.post.edit', function(ev, data) {
		ajaxify.go('compose?pid=' + data.pid);
	});

	$(window).on('action:composer.post.new', function(ev, data) {
		ajaxify.go(
			'compose?tid=' + data.tid +
			(data.pid ? '&toPid=' + data.pid : '') +
			(data.topicName ? '&title=' + encodeURIComponent(data.topicName) : '') +
			(data.text ? '&body=' + encodeURIComponent(data.text) : '')
		);
	});

	$(window).on('action:composer.addQuote', function(ev, data) {
		ajaxify.go('compose?tid=' + data.tid + '&toPid=' + data.pid + '&quoted=1&username=' + data.username);
	});

});
